import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { Task } from "../models/Task";
import { ValidationsReponse } from "@/modules/FormTemplate/models/ValidationsReponse";

export class TaskService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/tasks`;
  }

  async addTask(task: Task): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/add-task`;
    const response = await axios.post(serviceUrl, task);
    return response.data;
  }

  async deleteTask(id: string): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.delete(serviceUrl);
    return response.data;
  }

  async getTask(id: string): Promise<Response<any>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }

  async assignTask(
    taskId: string,
    responsible: string[]
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/assigned`;
    const response = await axios.put(serviceUrl, { taskId, responsible });
    return response.data;
  }

  async validateFormTemplateUsed(
    responsible: string[],
    formTemplateId: string,
    formTemplateName: string
  ): Promise<Response<ValidationsReponse>> {
    const serviceURL = `${this.baseUrl}/form-template-used`;
    const response = await axios.get(serviceURL, {
      params: { responsible, formTemplateId, formTemplateName }
    });
    return response.data;
  }

  async getTaskIdFromFormTemplate(
    formTemplateId: string,
    userId: string
  ): Promise<Response<any>> {
    const serviceUrl = `${this.baseUrl}/find-task-id-related-form/${formTemplateId}/${userId}`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }
}
